import { NumberFormatValues } from 'react-number-format';
import * as R from 'ramda';

import { NumericFormat } from '@atom/mui';

import { isMilePostValid, MILEPOST_TITLE } from './assetRouteUtilities';

import classes from './assetRouteTab.module.css';

type MilePostInputProps = {
  value: number;
  ranges: number[][];
  onChange: (value: number) => void;
  disabled?: boolean;
};

const formatRange = ([start, end]: number[]) => `${start} and ${end}`;
const formatRanges = (ranges: number[][]): string => {
  const formatted = ranges.map(formatRange);

  if (formatted.length === 1) {
    return formatted[0];
  }

  if (formatted.length === 2) {
    return `${formatted[0]} or ${formatted[1]}`;
  }

  const last = formatted[formatted.length - 1];
  return `${formatted.slice(0, -1).join(', ')}, or ${last}`;
};

const MilePostInput = ({
  value,
  ranges,
  onChange,
  disabled = false,
}: MilePostInputProps) => {
  const hasValue = !R.isNil(value);
  const isOutOfRange = hasValue && !isMilePostValid(value, ranges);
  const hasRanges = !R.isEmpty(ranges || []);

  const handleChange = (values: NumberFormatValues) => {
    if (values.floatValue !== value) {
      onChange(R.isNil(values.floatValue) ? null : values.floatValue);
    }
  };

  return (
    <div>
      <NumericFormat
        value={hasValue ? value : ''}
        onValueChange={handleChange}
        allowNegative={false}
        label={`${MILEPOST_TITLE} *`}
        error={isOutOfRange}
        disabled={disabled}
        data-cy="createAssetMilePostInput"
      />
      {hasRanges && (
        <div
          className={
            isOutOfRange ? classes.rangeSubtextError : classes.rangeSubtext
          }
        >
          {`Please provide a value between ${formatRanges(ranges)}`}
        </div>
      )}
    </div>
  );
};

export default MilePostInput;
